import { useEffect, useState } from "react";
import useDomainList from "../../../utils/CustomHooks/useDomainList";
import ResultSectionItem from "../Components/ResultSectionItem";
import CreateResultSection from "./CreateResultSection";
import UpdateResultSection from "./UpdateResultSection";
import { Popconfirm } from "antd";

export default function ResultSection(props) {
  let {
    screener = {},
    resultRangeList = [],
    refresh = () => {},
    onClose = () => {},
    onDone = () => {},
    onBack = () => {},
    isEditable,
    handleDiscord=()=>{}
  } = props;
  const [result, setResult] = useState({});
  const screener_history = result.pending_history ? result.pending_history : {};
  const hasUpdated = Boolean(screener_history && screener_history.updated_data);
  const [history, setHistory] = useState(false);
  useEffect(() => {
    refresh();
  }, []);
  const ActionComponent = result.screener_result_range_id
    ? UpdateResultSection
    : CreateResultSection;
  return (
    <div className="row justify-content-center ">
      <div className="col-md-12">
        <div className="table-responsive border p-2">
          <table className="table  table-striped questionnaire-table table-borderless  mb-0">
            <thead>
              <tr>
                <th className="text-center">Type</th>
                <th className="text-center">Reference</th>
                <th className="text-center">Color</th>
                <th className="text-center">Name</th>
                <th className="text-center">Min</th>
                <th className="text-center">Max</th>
                {/* <th className="">Meta Count</th> */}
                <th className="text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {resultRangeList.length > 0 ? (
                resultRangeList
                  .slice()
                  .filter((x)=>x?.active === true)
                  .sort((a, b) => a.sort_order - b.sort_order)
                  .map((x, i) => (
                    <ResultSectionItem
                      {...props}
                      item={x}
                      key={i}
                      isEditable={isEditable}
                      onEdit={setResult}
                      canDelete={!screener.published}
                      refresh={refresh}
                      setHistory={setHistory}
                    />
                  ))
              ) : (
                <tr>
                  <td className="text-center" colSpan="8">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      {isEditable && (
        <ActionComponent
          {...props}
          values={result}
          reset={() => setResult({})}
        />
      )}
      <div className="d-flex align-items-end justify-content-center col-md-12 p-5">
      {isEditable && (hasUpdated || history) && (
          <Popconfirm
            title="Are you sure to discard and close?"
            onConfirm={handleDiscord}
            //  onCancel={cancel}
            okText="Yes"
            cancelText="No"
          >
            <button
             type="button"
              className="btn btn-danger btn-sm float-right btn-add-domain mr-2"
            >
              Discard All & Close
            </button>
          </Popconfirm>
        )}
        <button
          onClick={onClose}
          type="button"
          className="btn btn-danger btn-sm float-right btn-add-domain mr-2"
        >
          Close
        </button>{" "}
        <button
          onClick={onBack}
          type="button"
          className="btn btn-error btn-sm float-right btn-add-domain mr-2"
        >
          Back
        </button>
        <button
          onClick={onDone}
          type="button"
          className="btn btn-secondary btn-sm float-right btn-add-domain mr-2"
        >
          Next
        </button>
      </div>
    </div>
  );
}
